import * as types from "./actionTypes";

const initialState = {
  isAuth: JSON.parse(localStorage.getItem("token")) ? true : false,
  isLoading: false,
  isError: false,
  token: JSON.parse(localStorage.getItem("token")) || "",
  admin: [],
  student: [],
  user: JSON.parse(localStorage.getItem("user")) || {},
};

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // ---------------------------Admin Signup starts here--------------------------------
    case types.ADMIN_SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case types.ADMIN_SIGNUP_SUCCESS:
      return {
        ...state,

        isLoading: false,
        isError: false,
        admin: payload,
      };
    case types.ADMIN_SIGNUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    // -----------------------------Student signup starts here-----------------------
    case types.STUDENT_SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: payload,
        isError: false,
      };
    case types.STUDENT_SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        student: payload,
      };
    case types.STUDENT_SIGNUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: payload,
      };

    // -------------------------User Login starts here-----------------------------
    case types.USER_LOGIN_REQUEST:
      return {
        ...state,
        isAuth: false,
        token: "",
        isLoading: true,
        isError: false,
      };
    case types.USER_LOGIN_SUCCESS:
      localStorage.setItem("token", JSON.stringify(payload.token));
      localStorage.setItem("user", JSON.stringify(payload.user));
      return {
        ...state,
        isAuth: true,
        isLoading: false,
        isError: false,
        token: payload.token,
        user: payload.user,
      };
    case types.USER_LOGIN_FAILURE:
      return {
        ...state,
        isAuth: false,
        token: "",
        isLoading: false,
        isError: payload,
      };
    default:
      return state;
  }
};
